/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Bedarfsituation
 */
export enum NeedSituationEnum {
    ANU_P_U = 'ANuP_U',
    SU_P_U = 'SuP_U',
    KANS_U = 'KANS_U',
    HMU_P_U = 'HMuP_U',
    KHM_U = 'KHM_U',
    SU_S_U = 'SuS_U',
    ANU_P = 'ANuP',
    SU_P = 'SuP',
    KANS = 'KANS',
    HMU_P = 'HMuP',
    KHM = 'KHM',
    SU_S = 'SuS',
    BU_P = 'BuP',
    BAU_P = 'BAuP',
    KB = 'KB',
    BU_P_U = 'BuP_U',
    BAU_P_U = 'BAuP_U',
    KB_U = 'KB_U',
    OPTI = 'OPTI',
    ZVGKV = 'ZVGKV',
    ZVGKV_U = 'ZVGKV_U',
}
